import React, { useState } from 'react';
import './styles.css';
import { Alert, Row, Col, Button, Form, Space, Modal } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import {
  DividerContainer,
  PageLayout,
  CheckboxForm,
  ButtonBackData,
  ConditionsText,
} from '@BUP/components';
import { useHistory } from 'react-router';
import {
  useAuth,
  useBraveUpSurveysApi,
  useConfirmActivationData,
  useDataFormPage,
} from '@BUP/hooks';
import { useTranslation } from 'react-i18next';

const DataTermsAndConditionsPage = () => {
  const history = useHistory();
  const [t] = useTranslation();
  const { user } = useAuth();
  const [terms, setTerms] = useState(false);
  const { survey } = useBraveUpSurveysApi();
  const { formValues, minValues } = useDataFormPage();
  const { organizations } = user;
  const { id: organizationId } = organizations;
  const { students, parents, teachers, assistants } = formValues;
  const { minParents, minStudents, minTeachers, minAssistants } = minValues;
  useConfirmActivationData();
  const { errorResponse, confirmActivation } = useConfirmActivationData();
  const onChangeTerms = (e) => {
    setTerms(e.target.checked);
  };

  const handleOk = () => {
    history.push('/data/instruments/activation-steps');
  };

  const handleClickConfirm = async () => {
    if (!survey) {
      const dataResponse = await confirmActivation({
        data: {
          students,
          studentsMin: minStudents,
          parents,
          parentsMin: minParents,
          teachers,
          teachersMin: minTeachers,
          teaching_assistants: assistants,
          teachingAssistansMin: minAssistants,
          organizationId,
        },
      });

      if (dataResponse) {
        Modal.confirm({
          title: t('pages.data.termsAndConditions.modalTitle'),
          icon: <CheckCircleOutlined style={{ color: 'green' }} />,
          content: (
            <div>
              <p>{t('pages.data.termsAndConditions.modalParagraph1')}</p>
              {t('pages.data.termsAndConditions.modalParagraph2')}
            </div>
          ),
          okText: t('pages.data.termsAndConditions.modalButtonDownloadText1'),
          okButtonProps: {
            onClick: () => {
              history.push('/data/instruments/activation-steps');
              Modal.destroyAll();
            },
          },
          onOk: { handleOk },
          cancelText: t('pages.data.termsAndConditions.modalBackButton'),
          cancelButtonProps: {
            onClick: () => {
              history.push('/data');
              Modal.destroyAll();
            },
          },
        });
      }
    }
  };

  return (
    <PageLayout>
      <ButtonBackData onClick={() => history.goBack()} />
      <DividerContainer title={t('pages.data.termsAndConditions.title')} />
      <ConditionsText />
      {errorResponse ? (
        <Alert
          message={`Error: ${errorResponse}`}
          type="error"
          showIcon
          className="termsAndConditions_error-message"
        />
      ) : null}

      {!survey ? (
        <Form>
          <Form.Item onChange={onChangeTerms}>
            <CheckboxForm
              checked={terms}
              textCheckbox={t('pages.data.termsAndConditions.checkboxText')}
            />
          </Form.Item>

          <Row align="center">
            <Col span={6}>
              <Button
                type="primary"
                size="large"
                className="termsAndConditions_button__back-button"
                onClick={() => history.goBack()}
              >
                {t('pages.data.termsAndConditions.backButton')}
              </Button>
            </Col>
            <Col span={6}>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  className="termsAndConditions_button__confirm-activation"
                  onClick={handleClickConfirm}
                  disabled={!terms}
                >
                  {t('pages.data.termsAndConditions.buttonConfirmText')}
                  <br />
                  {t('pages.data.termsAndConditions.buttonActivationText')}
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      ) : (
        <Alert
          message={t('pages.data.termsAndConditions.alertMessage')}
          type="info"
          showIcon
        />
      )}
    </PageLayout>
  );
};

export default DataTermsAndConditionsPage;
